import { Tag } from 'models/general';
import { GeoSystemTypes } from './enums/geo-system-types';
import { LanguageDirection } from './enums/language';

export const hexIsLight = (color: string): boolean => {
  let hex = color.replace('#', '');

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((h) => h + h)
      .join('');
  }

  const colorRed = parseInt(hex.substr(0, 2), 16);
  const colorGreen = parseInt(hex.substr(2, 2), 16);
  const ColorBlue = parseInt(hex.substr(4, 2), 16);
  const brightness = (colorRed * 299 + colorGreen * 587 + ColorBlue * 114) / 1000;

  return brightness > 135;
};

export const addPlusOrMinus = (number: number | string): string => {
  if (Number(number) > 0) {
    return `+${number}`;
  }

  return number.toString();
};

export const convertDistanceFromServer = (units: number, type: GeoSystemTypes): number => {
  return type === GeoSystemTypes.Metric ? Math.round(units / 1000) : Math.round(units / 1609.34);
};

export const convertDistanceToServer = (units: number, type: GeoSystemTypes): number => {
  return type === GeoSystemTypes.Metric ? units * 1000 : units * 1609.34;
};

export const makeNameAcronyms = (name: string): string => {
  return name
    .split(' ')
    .slice(0, 2)
    .map((word: string) => word.charAt(0))
    .join('')
    .toUpperCase();
};

export const extractValueFromTags = (tags?: Tag[], key?: string): string | null => {
  const value = tags?.find((tag: Tag) => tag.key === key);

  return value ? value.value : null;
};

export const removeLeadingTrailingSlashes = (str?: string): string | undefined => {
  return str?.replace(/^\/+|\/+$/g, '');
};

export const downloadFile = (url: string): void => {
  const a = document.createElement('a');

  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export const getCurrentDirection = (): LanguageDirection => {
  const htmlElement = document.documentElement;
  const computedStyle = getComputedStyle(htmlElement);

  return computedStyle.getPropertyValue('--direction').trim() as LanguageDirection; // Get the value of --direction
};
